<template>
  <div class="card">
    <transition name="highlight">
      <div class="highlight" v-if="showHighlight"></div>
    </transition>
    <h4 class="margin-t-z margin-b-z" v-if="charter.enabled">{{ $t('rsvpEdit.startDate') }}</h4>
    <h4 class="margin-t-z margin-b-z" v-else>{{ $t('rsvpEdit.pickupDate2') }}</h4>
    <div class="pickup-info">
      <div class="block-value" v-if="charter.enabled">{{ startDate }}</div>
      <div class="block-value" v-else>{{ pickupDate }}</div>
    </div>
  </div>
</template>

<script type="text/javascript">
import moment from 'moment'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'pickup-info',
  data: function () {
    return {
      showHighlight: false
    }
  },
  computed: {
    edited () { return this.$store.state.rsvpEdit.editedRsvp },
    pickupDate () {
      let self = this
      if (this.mtech.enabled) {
        return moment(self.edited.rawPickupDate, 'YYYY-MM-DD HH:mm:ss Z').tz(this.edited.pickupTimezone).format('MMMM DD, YYYY - ' + featureToggle.timeFormat(self, false))
      }
      return moment(self.$store.state.rsvpEdit.editedRsvp.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
        .format('MMMM DD, YYYY - ' + featureToggle.timeFormat(self, false))
    },
    startDate () {
      return moment(this.charter.startDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        .format('MMMM DD, YYYY - ' + featureToggle.timeFormat(this, false))
    },
    charter () { return this.$store.state.reservation.charter },
    mtech () { return this.$store.state.reservation.mtech }
  },
  watch: {
    pickupDate: function (value) {
      let self = this
      self.showHighlight = true
      setTimeout(function () {
        self.showHighlight = false
      }, 1000)
    },
    startDate: function (value) {
      let self = this
      self.showHighlight = true
      setTimeout(function () {
        self.showHighlight = false
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
h4{ color: #2c3e50; }
.pickup-info {
  position: relative;
  padding: 2px 0;

  & > * {
    display: inline-block;
    vertical-align: middle;
  }

  & .label {
    color: #777;
    width: 130px;
    margin-right: 10px;
    text-align: right;
    font-size: 14px;
  }
  & .value { font-size: 16px; }
  .block-value{
    font-size: 18px;
    color: #676767;
  }
}

.divider {
  display: block;
  height: 0;
  width: 100%;
  border-top: 1px solid rgba(0,0,0,0.2);
  margin: 10px 0;
}

.card{
  position: relative;
  overflow: hidden;
}
.highlight{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #ffd400;
  opacity: .4;
}
.highlight-small-enter-active, .highlight-small-leave-active { transition: all .9s ease; }
.highlight-small-enter, .highlight-small-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// PickupInfo.vue?5cefd7b0